import styled from 'styled-components';
import BackgroundURL from 'common/assets/images/login-background.jpg';
import LogoSVG from 'common/assets/icons/common/rock-west/rw-logo-with-text-large.svg';

const Container = styled.div`
  background: url(${BackgroundURL}) no-repeat;
  padding-top: 10vh;
  background-size: cover;
`;
const Icon = styled.div`
  background: url(${LogoSVG}) no-repeat;
  background-size: contain;
  display: block;
  width: 276px;
  height: 35px;
  margin: 0 auto 50px;
`;

export const S = {
  Container,
  Icon,
};
